import React, { useState } from "react";
import { Drawer, Button, message } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import "./RejectionHistoryPage.scss";

const getInitials = (name) => {
  if (!name) return '';

  const parts = name.trim().split(/[\s_]+/);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return parts.map(part => part.charAt(0).toUpperCase()).join('').substring(0, 2);
};

const RejectionHistoryPageDrawer = ({ visible, onClose, rejections, imageTitle, createdBy, createdOn, collabId, promptText=null, productId=null, inspirationImageUri=null }) => {
  const [collaborating, setCollaborating] = useState(null);

  const handleViewCollaboration = async (rejection) => {
    setCollaborating(rejection.id || rejection.qa_time);

    if(rejection.collab_id){
      window.open(`/collaborate-tool/${rejection.collab_id}?ai_image=true&productId=${productId}&promptText=${promptText}&inspirationImageUri=${inspirationImageUri}`, '_blank');
      setCollaborating(null);
    } else{
      console.error('Error opening collaboration:');
      message.error('Failed to open collaboration');
      setCollaborating(null);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };

    return date.toLocaleDateString('en-US', options);
  };

  const getRejectionNumber = (index) => {
    return rejections.length - index;
  };

  return (
    <Drawer
      className="rejection-history-drawer"
      title={<h3 className='manrope f-18 black-33 mb-0'>Rejection History</h3>}
      placement="right"
      onClose={onClose}
      visible={visible}
      width={650}
      closable={true}
    >
      <div className="rejection-history-drawer-content">
        <div className="page-header">
          <div className="image-info">
            <span className="image-title">{imageTitle || 'Untitled Image'}</span>
            <span className="image-meta">
              Created on {formatDate(createdOn)} by {createdBy}
            </span>
          </div>
        </div>

        <div className="rejections-list">
          {(!rejections || rejections.length === 0) ? (
            <div className="empty-state">
              <p>No rejection history found for this image.</p>
            </div>
          ) : (
            rejections.map((rejection, index) => (
              <div key={rejection.qa_time || index} className="rejection-card">
                <div className="rejection-header">
                  <div className="rejection-user-info">
                    <div className="user-avatar">
                      {getInitials(rejection.qa_person || rejection.rejected_by || rejection.done_by)}
                    </div>
                    <div className="rejection-meta">
                      <span className="user-name">{rejection.qa_person || rejection.rejected_by || rejection.done_by}</span>
                      <span className="rejection-time">
                        Rejected on {formatDate(rejection.qa_time || rejection.rejected_on || rejection.updated_on)}
                      </span>
                    </div>
                  </div>

                  {(rejection.feedback_link || rejection.collab_id || collabId) && (
                    <Button
                      className="view-collab-btn"
                      onClick={() => handleViewCollaboration(rejection)}
                      loading={collaborating === (rejection.id || rejection.qa_time)}
                    >
                      <img src="/img/ai_creator/collab.svg" alt="" className="collab-icon" />
                      View Collaboration
                    </Button>
                  )}
                </div>

                <div className="rejection-reason-box">
                  <div className="reason-number">
                    {getRejectionNumber(index)}
                  </div>
                  <div className="reason-text">
                    {rejection.rejection_details || rejection.reason || rejection.rejection_reason || 'Rejected by reviewer'}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </Drawer>
  );
};

export default RejectionHistoryPageDrawer;
